import { Config } from '../models/config';

export class ShelfParams {
    public size: number;
    public image: string;
    public imageHighlight: string;
    public imageWidth: number;
    public imageHeight: number;
    public zeroVerticalLine: number;
    public borderWidth: number;
    public correctionValue: number;
    public isDefault: boolean;
}

export class Language {
    public id: string;
    public icon: string;
    public countries: string[];
    public selected?: boolean;
}

export class AppSettings {
    public static CONFIG: Config = <Config>{};

    public static readonly URL_ROOT = '';
    public static readonly APP_WIDTH = 800;
    public static readonly APP_HEIGHT = 1280;

    public static readonly DEFAULT_LANGUAGE = 'en';

    public static readonly INACTIVITY_PERIOD = 60;
    public static readonly INACTIVITY_MESSAGE_PERIOD = 30;

    //public static readonly DEFAULT_ZONE = 'Face';    

    public static readonly PROD_TYPES = ['cleansing', 'care', 'special_care'];
    public static readonly RESULT_FIELD = 'productIdList';    

    public static readonly SHELF_WRAPPER_HEIGHT = 739;
    public static readonly DEFAULT_SHELF_HEIGHT = 108;   
}


// WEBPACK FOOTER //
// ./src/app/app.settings.ts